<template>
  <div class="app-container">
    <!-- 高风险运维操作 -->
    <div class="ops-panel">
      <div class="ops-panel__head">
        <i class="el-icon-warning-outline ops-panel__head-icon"></i>
        <span class="ops-panel__title">高风险运维操作</span>
        <span class="ops-panel__desc">以下操作不可撤销，请确认设备状态无误后再执行</span>
      </div>

      <div class="ops-panel__body">
        <!-- 手动结算 -->
        <el-form :inline="true" class="ops-item ops-item--settle">
          <div class="ops-item__title">
            <i class="el-icon-edit"></i>
            <span>手动结算</span>
          </div>
          <div class="ops-item__fields">
            <el-form-item label="订单号">
              <el-input placeholder="请输入订单号" v-model="tableForm.order_no" clearable></el-input>
            </el-form-item>
            <el-form-item label="设备号">
              <el-input placeholder="请输入设备号" v-model="tableForm.deviceid2" clearable></el-input>
            </el-form-item>
            <el-form-item label="故障码">
              <el-input placeholder="故障码" v-model="tableForm.fault_code" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-edit" type="warning" @click="handleSettleOrder">手动结算</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-edit" type="warning" @click="handleSettleOrder_QT">手动全退款</el-button>
            </el-form-item>
          </div>
          <div class="ops-item__tip">
            <i class="el-icon-info"></i>
            <span>确定自动结算失败才手动结算哦，此处慎用！</span>
          </div>
        </el-form>

        <!-- 解除占用 -->
        <el-form :inline="true" class="ops-item ops-item--release">
          <div class="ops-item__title">
            <i class="el-icon-delete"></i>
            <span>解除占用</span>
          </div>
          <div class="ops-item__fields">
            <el-form-item label="设备号">
              <el-input placeholder="请输入设备号" v-model="tableForm.deviceid" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-delete" type="danger" @click="releaseDevice">解除占用</el-button>
            </el-form-item>
          </div>
          <div class="ops-item__tip">
            <i class="el-icon-warning-outline"></i>
            <span>确定设备确实被占用了且订单无法结束，才点击这里（不结算哦），此处慎用！！！</span>
          </div>
        </el-form>
      </div>
    </div>
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="订单编号">
        <el-input placeholder="请输入订单编号" v-model="filter.order_no" clearable></el-input>
      </el-form-item>
      <el-form-item label="设备号">
        <el-input placeholder="请输入设备号" v-model="filter.device_id" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
      </el-form-item>
    </el-form>

    <el-card class="box-card">
      <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
        <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
        <el-table-column label="订单编号" prop="ordernum" width="240" align="center"> </el-table-column>
        <el-table-column label="设备编号" prop="deviceid" align="center" width="240"></el-table-column>
        <el-table-column label="状态" prop="status_name" align="center" width="80">
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.status == 1">{{ row.status_name }}</el-tag>
            <el-tag type="denger" v-else-if="row.status == 2">{{ row.status_name }}</el-tag>
            <el-tag type="info" v-else>{{ row.status_name }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="推送次数" prop="times" align="center"></el-table-column>
        <el-table-column label="创建时间" prop="create_time" width="190" align="center"></el-table-column>
        <el-table-column :label="$t('publics.operation')" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" @click="onDetail(row)" v-permision_tjtf="'detail'">详情</el-button>
            <el-button type="text" v-if="row.status == 2" @click="onDevRestart(row)" v-permision_tjtf="'dev_restart'">再次结算</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <div class="my-pagination">
      <el-pagination
        background
        layout="sizes,total,prev,pager,next,jumper"
        :total="pageParams.total"
        :page-size="pageParams.limit"
        :page-sizes="[5, 10, 50, 100, 500, 1000]"
        :current-page="pageParams.page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>

    <!-- 设备状态详情弹窗 -->
    <el-dialog :visible.sync="detailVisible" title="详情" width="1300px" :close-on-click-modal="false" class="detail-dialog lower_formitem_box">
      <el-row type="flex" justify="center">
        <el-col :span="24">
          <el-form label-position="right" label-width="120px" :model="detailForm" ref="detailForm" style="padding: 0px 30px">
            <!-- 1. 档案信息（triplet） -->
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="资产码" prop="assetsCode">
                  <el-input v-model="detailForm.assetsCode" readonly disabled />
                </el-form-item>
                <el-form-item label="出厂编码" prop="FactoryCode">
                  <el-input v-model="detailForm.FactoryCode" readonly disabled />
                </el-form-item>

                <el-form-item label="公钥" prop="PublickKey">
                  <el-input v-model="detailForm.PublickKey" readonly disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="私钥" prop="SecrtKey">
                  <el-input v-model="detailForm.SecrtKey" readonly disabled />
                </el-form-item>
                <el-form-item label="注册码" prop="RegCode">
                  <el-input v-model="detailForm.RegCode" readonly disabled />
                </el-form-item>
                <el-form-item label="类型名称" prop="TypeName">
                  <el-input v-model="detailForm.TypeName" readonly disabled />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="状态" prop="State">
                  <el-input v-model="detailForm.State" readonly disabled />
                </el-form-item>
                <el-form-item label="创建时间" prop="CreateTime">
                  <el-input v-model="detailForm.CreateTime" readonly disabled />
                </el-form-item>
                <el-form-item label="" prop="triplet_id"> </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button @click="detailVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import fileUpload from "@/components/fileUpload/fileUpload.vue"

import { GetOrderSettlePushPageList, setteOrderByHand, setteOrderByHand_QT } from "@/api/order_settle_push"

import { unlockDeviceApi } from "@/api/dev_archive"

import { Send_DevRestart, Send_QuerySim, Send_TimeSync } from "@/api/dev_send_order"
import { mapGetters } from "vuex"

export default {
  name: "GroupManage",
  mixins: [pageMixin],
  components: {},
  data() {
    return {
      tableData: [],
      visible: {
        curve: false,
        ordercurve: false
      },
      filter: {
        device_id: "",
        order_no: ""
      },
      loading: false,
      isUpdate: true,
      gid: "",
      detailVisible: false,
      modelParams: {},
      detailForm: {
        // 基本档案信息
        ID: "",
        triplet: {},
        firmware_evt: {},
        acDeRealIty: {},
        verinfo_evt: {},
        dev_inform_evt: {},
        status: 0,
        re_dev_type: "",
        dev_type: 0
      },
      tableForm: {
        deviceid: "",
        deviceid2: "",
        order_no: "",
        fault_code: ""
      }
    }
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  created() {
    this.getData()
  },
  methods: {
    toFilter() {
      this.pageParams.page = 1
      this.getData()
    },
    handleSizeChange(val) {
      this.pageParams.limit = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.pageParams.page = val
      this.getData()
    },
    onDetail(row) {
      this.detailVisible = true
    },
    getData() {
      this.loading = true
      GetOrderSettlePushPageList({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        order_no: this.filter.order_no || null,
        device_id: this.filter.device_id || null
      })
        .then((res) => {
          this.tableData = res.data
          this.pageParams.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleSettleOrder() {
      if (this.tableForm.order_no && this.tableForm.order_no.trim().length > 0 && this.tableForm.deviceid2 && this.tableForm.deviceid2.trim().length > 0) {
        this.$confirm("确定要手动结算此订单？此操作不可恢复！", "警告", {
          confirmButtonText: "确定结算",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          setteOrderByHand({ order_no: this.tableForm.order_no, device_id: this.tableForm.deviceid2, faultCode: this.tableForm.fault_code }).then((res) => {
            this.$message.success(res.msg)
          })
        })
      } else {
        this.$message({
          message: "请输入需要结算的订单号和设备号",
          type: "warning"
        })
      }
    },
    handleSettleOrder_QT() {
      if (this.tableForm.order_no && this.tableForm.order_no.trim().length > 0 && this.tableForm.deviceid2 && this.tableForm.deviceid2.trim().length > 0) {
        this.$confirm("确定要手动结算此订单？此操作不可恢复！", "警告", {
          confirmButtonText: "确定全额退款结算",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          setteOrderByHand_QT({ order_no: this.tableForm.order_no, device_id: this.tableForm.deviceid2, faultCode: this.tableForm.fault_code }).then((res) => {
            this.$message.success(res.msg)
          })
        })
      } else {
        this.$message({
          message: "请输入需要结算的订单号和设备号",
          type: "warning"
        })
      }
    },

    releaseDevice() {
      if (this.tableForm.deviceid && this.tableForm.deviceid.trim().length > 0) {
        this.$confirm("确定要解除占用的设备号？此操作不可恢复！", "警告", {
          confirmButtonText: "确定解除",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          unlockDeviceApi({ deviceid: this.tableForm.deviceid }).then((res) => {
            this.$message.success(res.msg)
          })
        })
      } else {
        this.$message({
          message: "请输入需要解除占用的设备号",
          type: "warning"
        })
      }
    }
  }
}
</script>

<style scoped>
/* 页面整体：纵向自适应填充，内容区内部滚动 */
.app-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* ---------- 高风险运维操作区 ---------- */
.ops-panel {
  flex-shrink: 0;
  margin-bottom: 12px;
  padding: 12px 16px 8px;
  background: #fffbf3;
  border: 1px solid #f7e2c0;
  border-radius: 8px;
}

.ops-panel__head {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.ops-panel__head-icon {
  margin-right: 6px;
  font-size: 16px;
  color: #e6a23c;
}

.ops-panel__title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.ops-panel__desc {
  margin-left: 10px;
  font-size: 12px;
  color: #b88230;
}

.ops-panel__body {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -8px;
}

.ops-item {
  box-sizing: border-box;
  display: flex;
  flex: 1 1 460px;
  flex-direction: column;
  margin: 0 8px 8px;
  padding: 12px 16px;
  background: #fff;
  border: 1px solid #ebeef5;
  border-left: 3px solid #e6a23c;
  border-radius: 6px;
  transition: box-shadow 0.2s;
}

.ops-item:hover {
  box-shadow: 0 2px 10px rgba(230, 162, 60, 0.15);
}

.ops-item--release {
  border-left-color: #f56c6c;
}

.ops-item--release:hover {
  box-shadow: 0 2px 10px rgba(245, 108, 108, 0.15);
}

.ops-item__title {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #303133;
}

.ops-item__title i {
  margin-right: 6px;
  font-size: 14px;
  color: #e6a23c;
}

.ops-item--release .ops-item__title i {
  color: #f56c6c;
}

.ops-item__fields {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.ops-item__fields ::v-deep .el-form-item {
  margin-right: 12px;
  margin-bottom: 8px;
}

.ops-item__fields ::v-deep .el-input {
  width: 180px;
}

.ops-item__tip {
  display: flex;
  align-items: flex-start;
  margin-top: auto;
  padding-top: 8px;
  border-top: 1px dashed #f2e4cd;
  font-size: 12px;
  line-height: 18px;
  color: #b88230;
}

.ops-item--release .ops-item__tip {
  border-top-color: #f9e0e0;
  color: #d2696a;
}

.ops-item__tip i {
  margin-right: 4px;
  padding-top: 2px;
  font-size: 13px;
}

/* ---------- 表格区域：占满剩余高度 ---------- */
.box-card {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.box-card ::v-deep .el-card__body {
  flex: 1;
  min-height: 0;
  padding: 0;
  overflow: hidden;
}

.my-pagination {
  flex-shrink: 0;
  margin-top: 12px;
  text-align: right;
}

/* 去除详情对话框的内外边距 */
.detail-dialog ::v-deep .el-dialog {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.zanwu {
  line-height: 50px;
  text-align: center;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
}
</style>
